export default "__VITE_ASSET__CHs$Wcb3__";